import { NavLink } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setHeadings, setselectedTab } from "../Store/B2bslice";
import {
  BsBank,
  BsBank2,
  BsBusFrontFill,
  BsListUl,
  BsPaypal,
  BsPeople,
  BsQrCode,
} from "react-icons/bs";
import {
  FaCertificate,
  FaMoneyBill,
  FaMoneyCheck,
  FaRupeeSign,
} from "react-icons/fa";
import {
  MdAccountBalance,
  MdOutlineFlight,
  MdOutlinePayments,
  MdOutlineTravelExplore,
  MdReport,
} from "react-icons/md";
import { TbFileInvoice, TbRecharging } from "react-icons/tb";
import { IoCashOutline, IoDocumentTextSharp } from "react-icons/io5";
import { BiRun, BiSolidHotel, BiTransferAlt } from "react-icons/bi";
import { FaRegAddressCard } from "react-icons/fa6";
import { FcTodoList } from "react-icons/fc";
import { saveAs } from "file-saver";
import {
  AiOutlineHome,
  AiOutlineHistory,
  AiOutlineWallet,
} from "react-icons/ai";
import { Tooltip } from "antd";
import { getLocalStorageItem } from "../Utils";
import axios from "axios";
import { APIURL } from "../ApiServices/Axios";
import { Globalendpoints } from "../ApiServices/global";
import { ThemeColor } from "../Theme/theme";
import { RiBillLine } from "react-icons/ri";

export const Menuitems = () => {
  const dispatch = useDispatch();
  const profiledetail = useSelector((state) => state.B2B.profileDetail);
  const memberServices = useSelector((state) => state.B2B.memberServices);

  const checkStatus = (to) => {
    if (!profiledetail.aeps_onboard) {
      return "/banking/aeps-onboard";
    } else if (!profiledetail.ekyc_status) {
      return "/banking/aeps-ekyc";
    } else if (!profiledetail.twofa_status) {
      return "/banking/aeps";
    } else {
      return to;
    }
  };

  const checkEkoStatus = (to) => {
    if (!profiledetail.eko_aeps_service_status == 1) {
      return "/banking/aeps-eko-onboard";
    } else if (!profiledetail.eko_aeps_ekyc_status) {
      return "/banking/aeps-eko-ekyc";
    } else if (!profiledetail.twofa_status) {
      return "/banking/aeps-eko";
    } else {
      return to;
    }
  };

  const checkWithdrawalStatus = (to) => {
    if (!profiledetail.aeps_onboard) {
      return "/banking/aeps-onboard";
    } else if (!profiledetail.ekyc_status) {
      return "/banking/aeps-ekyc";
    } else if (!profiledetail.twofa_status) {
      return "/banking/aeps";
    }
    //  else if (withdrawalTime === 0) {
    //   return "/banking/aeps";
    // }
    else {
      return to;
    }
  };
  const checkYesBankStatus = (to) => {
    if (
      profiledetail.bank2_aeps_memberkyc == "3" ||
      profiledetail.bank2_aeps_memberkyc == "2" ||
      profiledetail.bank2_aeps_memberkyc == "0"
    ) {
      return "/banking/aepsyes-memberkyc";
    } else if (!profiledetail.bank2_aeps_onboard) {
      return "/banking/aepsyes-onboard";
    } else {
      return to;
    }
  };
  const checkCredoStatus = () => {
    if (!profiledetail.credo_aeps_onboard) {
      return "/banking/aeps2-onboard";
    } else if (!profiledetail.credo_aeps_status) {
      return "/banking/waiting";
    } else if (
      profiledetail.credo_aeps_onboard &&
      profiledetail.credo_aeps_status
    ) {
      return "/banking/aeps2-2fa";
    }
  };

  const checkDigiStatus = () => {
    if (
      profiledetail.digio_kyc === "0" ||
      profiledetail.digio_kyc === "2" ||
      profiledetail.digio_kyc === "3"
    ) {
      return true;
    }
  };
  const checkEKOonboardStatus = () => {
    if (profiledetail.eko_onboard_status == "0") {
      return true;
    }
  };

  const list = [
    {
      key: "1",
      icon: <AiOutlineHome />,
      label: (
        <NavLink to={"/dashboard"}>
          <p>Dashboard</p>
        </NavLink>
      ),
      onClick: () => {
        dispatch(setselectedTab("1"));
        dispatch(setHeadings("Dashboard"));
      },
    },
    profiledetail.member_type !== "State Head" &&
      profiledetail.member_type_id !== "2" &&
      profiledetail.member_type_id !== "3" &&
      (memberServices.includes("1") || memberServices.includes("115")) && {
        key: "2",
        icon: <TbRecharging />,
        label: (
          <NavLink
            to={
              memberServices.includes("1")
                ? "/recharge"
                : memberServices.includes("115")
                  ? "/recharge2"
                  : "/not-available"
            }
          >
            <p>Recharge</p>
          </NavLink>
        ),
        onClick: () => {
          dispatch(setselectedTab("2"));
          dispatch(setHeadings("Recharge & Bill Payment"));
        },
      },
    // {
    //   key: "2",
    //   icon: <TbRecharging />,
    //   label: (
    //     <NavLink
    //       to={memberServices.includes("1") ? "/recharge" : "/not-available"}
    //     >
    //       <p>Recharge</p>
    //     </NavLink>
    //   ),
    //   onClick: () => {
    //     dispatch(setselectedTab("2"));
    //     dispatch(setHeadings("Recharge & Bill Payment"));
    //   },
    // }

    // profiledetail.member_type !== "State Head" &&
    //   profiledetail.member_type_id !== "2" &&
    //   profiledetail.member_type_id !== "3" && {
    //     key: "201",
    //     icon: <FaMoneyBill />,
    //     label: (
    //       <NavLink
    //         to={
    //           memberServices.includes("103")
    //             ? checkEKOonboardStatus()
    //               ? "/ekoOnboardStatus"
    //               : "/eko/bbps"
    //             : memberServices.includes("2")
    //             ? "/bbps"
    //             : "/not-available"
    //         }
    //       >
    //         <p>BBPS</p>
    //       </NavLink>
    //     ),
    //     onClick: () => {
    //       dispatch(setselectedTab("201"));
    //       dispatch(setHeadings("Recharge & Bill Payment"));
    //     },
    //   },
    // {
    //   key: "300.9",
    //   label: (
    //     <NavLink
    //       to={
    //         checkEKOonboardStatus()
    //           ? "/ekoOnboardStatus"
    //           : memberServices.includes("103")
    //           ? "/eko/bbps"
    //           : "/not-available"
    //       }
    //     >
    //       <p> BBPS</p>
    //     </NavLink>
    //   ),
    //   onClick: () => {
    //     dispatch(setselectedTab("300.9"));
    //   },
    // },
    // {
    //   key: "17",
    //   icon: <BsBank />,
    //   label: (
    //     <NavLink
    //       to={
    //         checkDigiStatus()
    //           ? "/kycStatus"
    //           : memberServices.includes("20")
    //           ? checkYesBankStatus("/banking/aeps-yesbank")
    //           : "/not-available"
    //       }
    //     >
    //       <p>AEPS Yes Bank</p>
    //     </NavLink>
    //   ),
    //   // children: [
    //   //   {
    //   //     key: "17.2",
    //   //     icon: <FaRupeeSign />,
    //   //     label: (
    //   //       <NavLink
    //   //         to={
    //   //           checkDigiStatus()
    //   //             ? "/kycStatus"
    //   //             : memberServices.includes("20")
    //   //             ? checkYesBankStatus("/banking/aepsyes-cash-withdrawl")
    //   //             : "/not-available"
    //   //         }
    //   //         state={{ from: "/banking/aepsyes-cash-withdrawl" }}
    //   //       >
    //   //         <p>Cash Withdrawl</p>
    //   //       </NavLink>
    //   //     ),
    //   //     onClick: () => {
    //   //       dispatch(setselectedTab("17.2"));
    //   //       dispatch(setHeadings("Cash Withdrawl"));
    //   //     },
    //   //   },
    //   //   {
    //   //     key: "17.4",
    //   //     icon: <IoDocumentTextSharp />,
    //   //     label: (
    //   //       <NavLink
    //   //         to={
    //   //           checkDigiStatus()
    //   //             ? "/kycStatus"
    //   //             : memberServices.includes("20")
    //   //             ? checkYesBankStatus("/banking/aepsyes-miniStatement")
    //   //             : "/not-available"
    //   //         }
    //   //         state={{ from: "/banking/aepsyes-miniStatement"}}
    //   //       >
    //   //         <p>Mini Statement</p>
    //   //       </NavLink>
    //   //     ),
    //   //     onClick: () => {
    //   //       dispatch(setselectedTab("17.4"));
    //   //       dispatch(setHeadings("Mini statement"));
    //   //     },
    //   //   },
    //   //   {
    //   //     key: "17.5",
    //   //     icon: <MdAccountBalance />,
    //   //     label: (
    //   //       <NavLink
    //   //         to={
    //   //         checkDigiStatus()
    //   //         ? "/kycStatus"
    //   //         : memberServices.includes("20")
    //   //         ? checkYesBankStatus("/banking/aepsyes-balanceEnquiry")
    //   //         : "/not-available"
    //   //         }
    //   //         state={{ from: "/banking/aepsyes-balanceEnquiry"}}
    //   //       >
    //   //         <p>Balance Enquiry</p>
    //   //       </NavLink>
    //   //     ),
    //   //     onClick: () => {
    //   //       dispatch(setselectedTab("17.5"));
    //   //       dispatch(setHeadings("Balance Enquiry"));
    //   //     },
    //   //   },
    //   // ],
    // },
    {
      key: "171",
      icon: <FaCertificate />,
      label: (
        // <NavLink
        //   to={
        //     checkDigiStatus()
        //       ? "/kycStatus"
        //       : memberServices.includes("20")
        //       ? checkYesBankStatus("/banking/aeps-yesbank")
        //       : "/not-available"
        //   }
        // >
        <p>BC Certificate</p>
        // </NavLink>
      ),
      onClick: () => {
        dispatch(setselectedTab("171"));
        axios
          .get(APIURL + "Api/V1/Member/yesBankCertificateDownload", {
            responseType: "blob",
            headers: {
              "Content-Type": "application/pdf",
              // Range: "bytes=0-999999",
              Authorization: `Bearer ${getLocalStorageItem("access_token")}`,
            },
          })
          .then((res) => {
            saveAs(res.data, "BC certificate.pdf");
          })
          .catch((err) => console.log(err));
      },
    },
    profiledetail.member_type !== "State Head" &&
      profiledetail.member_type_id !== "2" &&
      profiledetail.member_type_id !== "3" &&
      (memberServices.includes("8") ||
        memberServices.includes("25") ||
        memberServices.includes("114")) && {
        key: "117",
        icon: <FaMoneyBill />,
        label: (
          <NavLink to={"/aepsBankingServiceMain"}>
            <p>AEPS</p>
          </NavLink>
        ),
        onClick: () => {
          dispatch(setselectedTab("117"));
          dispatch(setHeadings("AEPS"));
        },
      },
    profiledetail.member_type !== "State Head" &&
      profiledetail.member_type_id !== "2" &&
      profiledetail.member_type_id !== "3" &&
      (memberServices.includes("103") ||
        memberServices.includes("110") ||
        memberServices.includes("2") ||
        memberServices.includes("116") ||
        memberServices.includes("117") ||
        memberServices.includes("118")) && {
        key: "201",
        icon: <FaMoneyBill />,
        label: (
          <NavLink to={"/bbpsServiceMain"}>
            <p>BBPS</p>
          </NavLink>
        ),
        onClick: () => {
          dispatch(setselectedTab("201"));
          dispatch(setHeadings("BBPS"));
        },
      },

    profiledetail.member_type !== "State Head" &&
      profiledetail.member_type_id !== "2" &&
      profiledetail.member_type_id !== "3" &&
      memberServices.includes("105") && {
        key: "300.6",
        icon: <FaMoneyBill />,
        label: (
          <NavLink to={"/cmsServiceMain"}>
            <p>CMS</p>
          </NavLink>
        ),
        onClick: () => {
          dispatch(setselectedTab("300.6"));
          dispatch(setHeadings("BBPS"));
        },
      },
    // profiledetail.member_type !== "State Head" &&
    //   profiledetail.member_type_id !== "2" &&
    //   profiledetail.member_type_id !== "3" && {
    //     key: "300.12",
    //     icon: <FaMoneyBill />,
    //     label: (
    //       <NavLink to={"/dmtServiceMain"}>
    //         <p>DMT</p>
    //       </NavLink>
    //     ),
    //     onClick: () => {
    //       dispatch(setselectedTab("300.6"));
    //       dispatch(setHeadings("BBPS"));
    //     },
    //   },
    (memberServices.includes("111") || memberServices.includes("121")) &&
      profiledetail.member_type !== "State Head" &&
      profiledetail.member_type_id !== "2" &&
      profiledetail.member_type_id !== "3" && {
        key: "300.11",
        icon: <FaMoneyBill />,
        label: (
          <NavLink to={"/creditCardServiceMain"}>
            <p>Credit Card</p>
          </NavLink>
        ),
        onClick: () => {
          dispatch(setselectedTab("300.11"));
          dispatch(setHeadings("Credit Card"));
        },
      },
    //  profiledetail.member_type !== "State Head" &&
    //       profiledetail.member_type_id !== "2" &&
    //       profiledetail.member_type_id !== "3" && {
    //         key: "117",
    //         icon: <FaMoneyBill />,
    //         label: (
    //           <NavLink
    //             to={
    //               memberServices.includes("25")
    //                 ? checkCredoStatus()
    //                 : "/not-available"
    //             }
    //           >
    //             <p>AEPS-2</p>
    //           </NavLink>
    //         ),
    //       },
    // profiledetail.member_type !== "State Head" &&
    //   profiledetail.member_type_id !== "2" &&
    //   profiledetail.member_type_id !== "3" && {
    //     key: "3",
    //     icon: <BsBank />,
    //     label: (
    //       <NavLink>
    //         <p>AEPS</p>
    //       </NavLink>
    //     ),
    //     children: [
    //       // {
    //       //   key: "3.1",
    //       //   icon: <IoCashOutline />,
    //       //   label: (
    //       //     <NavLink
    //       //       to={
    //       //         checkDigiStatus()
    //       //           ? "/kycStatus"
    //       //           : memberServices.includes("8")
    //       //           ? checkWithdrawalStatus("/banking/aeps-cash-deposit")
    //       //           : "/not-available"
    //       //       }
    //       //       state={{ from: "/banking/aeps-cash-deposit", type: "aeps" }}
    //       //     >
    //       //       <p>Cash Deposit</p>
    //       //     </NavLink>
    //       //   ),
    //       //   onClick: () => {
    //       //     dispatch(setselectedTab("3.1"));
    //       //     dispatch(setHeadings("Cash Withdrawl"));
    //       //   },
    //       // },
    //       {
    //         key: "3.2",
    //         icon: <FaRupeeSign />,
    //         label: (
    //           <NavLink
    //             to={
    //               checkDigiStatus()
    //                 ? "/kycStatus"
    //                 : memberServices.includes("8")
    //                 ? checkWithdrawalStatus("/banking/aeps-cash-withdrawl")
    //                 : "/not-available"
    //             }
    //             state={{ from: "/banking/aeps-cash-withdrawl", type: "aeps" }}
    //           >
    //             <p>Cash Withdrawal </p>
    //           </NavLink>
    //         ),
    //         onClick: () => {
    //           dispatch(setselectedTab("3.2"));
    //           dispatch(setHeadings("Cash Withdrawal "));
    //         },
    //       },
    //       {
    //         key: "3.3",
    //         icon: <FaRupeeSign />,
    //         label: (
    //           <NavLink
    //             to={
    //               checkDigiStatus()
    //                 ? "/kycStatus"
    //                 : memberServices.includes("8")
    //                 ? checkWithdrawalStatus("/banking/aeps-aadharpay")
    //                 : "/not-available"
    //             }
    //             state={{ from: "/banking/aeps-aadharpay", type: "aadhar_pay" }}
    //           >
    //             <p>Aadhar pay</p>
    //           </NavLink>
    //         ),
    //         onClick: () => {
    //           dispatch(setselectedTab("3.3"));
    //           dispatch(setHeadings("Aadhar Pay"));
    //         },
    //       },
    //       {
    //         key: "3.4",
    //         icon: <IoDocumentTextSharp />,
    //         label: (
    //           <NavLink
    //             to={
    //               checkDigiStatus()
    //                 ? "/kycStatus"
    //                 : memberServices.includes("8")
    //                 ? checkStatus("/banking/aeps-miniStatement")
    //                 : "/not-available"
    //             }
    //             state={{ from: "/banking/aeps-miniStatement", type: "aeps" }}
    //           >
    //             <p>Mini Statement</p>
    //           </NavLink>
    //         ),
    //         onClick: () => {
    //           dispatch(setselectedTab("3.4"));
    //           dispatch(setHeadings("Mini statement"));
    //         },
    //       },
    //       {
    //         key: "3.5",
    //         icon: <MdAccountBalance />,
    //         label: (
    //           <NavLink
    //             to={
    //               checkDigiStatus()
    //                 ? "/kycStatus"
    //                 : memberServices.includes("8")
    //                 ? checkStatus("/banking/aeps-balanceEnquiry")
    //                 : "/not-available"
    //             }
    //             state={{ from: "/banking/aeps-balanceEnquiry", type: "aeps" }}
    //           >
    //             <p>Balance Enquiry</p>
    //           </NavLink>
    //         ),
    //         onClick: () => {
    //           dispatch(setselectedTab("3.5"));
    //           dispatch(setHeadings("Balance Enquiry"));
    //         },
    //       },
    //     ],
    //   },
    profiledetail.member_type_id === "4" && // RT
      memberServices.includes("107") && {
        key: "300",
        icon: <RiBillLine />,
        label: (
          <NavLink>
            <p>Service 2</p>
          </NavLink>
        ),
        children: [
          // {
          //   key: "300.2",
          //   label: (
          //     <NavLink
          //       to={
          //         checkEKOonboardStatus()
          //           ? "/ekoOnboardStatus"
          //           : memberServices.includes("101")
          //           ? "/eko/payout"
          //           : "/not-available"
          //       }
          //     >
          //       <p>Payout</p>
          //     </NavLink>
          //   ),
          //   onClick: () => {
          //     dispatch(setselectedTab("300.2"));
          //   },
          // },
          // {
          //   key: "300.3",
          //   label: (
          //     <NavLink
          //       to={
          //         memberServices.includes("109") ? "/eko/qr" : "/not-available"
          //       }
          //     >
          //       <p>Dynamic Qr </p>
          //     </NavLink>
          //   ),
          //   onClick: () => {
          //     dispatch(setselectedTab("300.3"));
          //   },
          // },
          // {
          //   key: "300.14",
          //   label: (
          //     <NavLink
          //       to={
          //         memberServices.includes("119")
          //           ? "/eko/static/qr"
          //           : "/not-available"
          //       }
          //     >
          //       <p>Static Qr </p>
          //     </NavLink>
          //   ),
          //   onClick: () => {
          //     dispatch(setselectedTab("300.14"));
          //   },
          // },
          // {
          //   key: "300.4",
          //   label: (
          //     <NavLink
          //       to={
          //       memberServices.includes("106")
          //           ? "/eko/bank-verify"
          //           : "/not-available"
          //       }
          //     >
          //       <p> Bank Verify</p>
          //     </NavLink>
          //   ),
          //   onClick: () => {
          //     dispatch(setselectedTab("300.4"));
          //   },
          // },
          {
            key: "300.5",
            label: (
              <NavLink
                to={
                  // checkEKOonboardStatus()
                  //   ? "/ekoOnboardStatus"
                  //   : memberServices.includes("107")
                  //   ? "/eko/pan-verify"
                  //   : "/not-available"
                  "/eko/pan-verify"
                }
              >
                <p> Pan Verify</p>
              </NavLink>
            ),
            onClick: () => {
              dispatch(setselectedTab("300.5"));
            },
          },
          // {
          //   key: "300.6",
          //   label: (
          //     <NavLink
          //       to={
          //         memberServices.includes("105") ? "/eko/cms" : "/not-available"
          //       }
          //     >
          //       <p> CMS</p>
          //     </NavLink>
          //   ),
          //   onClick: () => {
          //     dispatch(setselectedTab("300.6"));
          //   },
          // },
          // {
          //   key: "300.7",
          //   label: (
          //     <NavLink
          //       to={
          //         checkEKOonboardStatus()
          //           ? "/ekoOnboardStatus"
          //           : memberServices.includes("102")
          //           ? "/eko/express-payout"
          //           : "/not-available"
          //       }
          //     >
          //       <p> Express</p>
          //     </NavLink>
          //   ),
          //   onClick: () => {
          //     dispatch(setselectedTab("300.7"));
          //   },
          // },
          // {
          //   key: "300.8",
          //   label: (
          //     <NavLink
          //       to={
          //         memberServices.includes("108")
          //           ? "/eko/aadhar-verify"
          //           : "/not-available"
          //       }
          //     >
          //       <p> Aadhar Verify</p>
          //     </NavLink>
          //   ),
          //   onClick: () => {
          //     dispatch(setselectedTab("300.8"));
          //   },
          // },
          // {
          //   key: "300.9",
          //   label: (
          //     <NavLink
          //       to={
          //         checkEKOonboardStatus()
          //           ? "/ekoOnboardStatus"
          //           : memberServices.includes("103")
          //           ? "/eko/bbps"
          //           : "/not-available"
          //       }
          //     >
          //       <p> BBPS</p>
          //     </NavLink>
          //   ),
          //   onClick: () => {
          //     dispatch(setselectedTab("300.9"));
          //   },
          // },
          // {
          //   key: "300.10",
          //   label: (
          //     <NavLink
          //       to={
          //         memberServices.includes("110")
          //           ? "/eko/bbps-offline"
          //           : "/not-available"
          //       }
          //     >
          //       <p> BBPS Offline</p>
          //     </NavLink>
          //   ),
          //   onClick: () => {
          //     dispatch(setselectedTab("300.10"));
          //   },
          // },
          // {
          //   key: "300.11",
          //   label: (
          //     <NavLink
          //       to={
          //         memberServices.includes("111")
          //           ? "/eko/credit-card"
          //           : "/not-available"
          //       }
          //     >
          //       <p> Credit Card</p>
          //     </NavLink>
          //   ),
          //   onClick: () => {
          //     dispatch(setselectedTab("300.11"));
          //   },
          // },
          // {
          //   key: "300.12",

          //   label: (
          //     <NavLink
          //       to={
          //         checkEKOonboardStatus()
          //           ? "/ekoOnboardStatus"
          //           : memberServices.includes("104")
          //           ? "/eko/dmt-service"
          //           : "/not-available"
          //       }
          //     >
          //       <p> DMT</p>
          //     </NavLink>
          //   ),
          //   onClick: () => {
          //     dispatch(setselectedTab("300.12"));
          //   },
          // },
          // {
          //   key: "300.13",
          //   icon: <BsBank />,
          //   label: (
          //     <NavLink>
          //       <p>AEPS</p>
          //     </NavLink>
          //   ),
          //   children: [
          //     {
          //       key: "3.22",
          //       icon: <FaRupeeSign />,
          //       label: (
          //         <NavLink
          //           to={
          //             memberServices.includes("114")
          //               ? checkEkoStatus("/banking/aeps-eko-cash-withdrawl")
          //               : "/not-available"
          //           }
          //           state={{
          //             from: "/banking/aeps-cash-withdrawl",
          //             type: "aeps",
          //           }}
          //         >
          //           <p>Cash Withdrawal </p>
          //         </NavLink>
          //       ),
          //       onClick: () => {
          //         dispatch(setselectedTab("3.22"));
          //         dispatch(setHeadings("Cash Withdrawal "));
          //       },
          //     },
          //     {
          //       key: "3.44",
          //       icon: <IoDocumentTextSharp />,
          //       label: (
          //         <NavLink
          //           to={
          //             memberServices.includes("114")
          //               ? checkEkoStatus("/banking/aeps-eko-miniStatement")
          //               : "/not-available"
          //           }
          //           state={{
          //             from: "/banking/aeps-miniStatement",
          //             type: "aeps",
          //           }}
          //         >
          //           <p>Mini Statement</p>
          //         </NavLink>
          //       ),
          //       onClick: () => {
          //         dispatch(setselectedTab("3.44"));
          //         dispatch(setHeadings("Mini statement"));
          //       },
          //     },
          //     {
          //       key: "3.55",
          //       icon: <MdAccountBalance />,
          //       label: (
          //         <NavLink
          //           to={
          //             memberServices.includes("114")
          //               ? checkEkoStatus("/banking/aeps-eko-balanceEnquiry")
          //               : "/not-available"
          //           }
          //           state={{
          //             from: "/banking/aeps-balanceEnquiry",
          //             type: "aeps",
          //           }}
          //         >
          //           <p>Balance Enquiry</p>
          //         </NavLink>
          //       ),
          //       onClick: () => {
          //         dispatch(setselectedTab("3.55"));
          //         dispatch(setHeadings("Balance Enquiry"));
          //       },
          //     },
          //   ],
          // },
        ],
      },
    // profiledetail.member_type !== "State Head" &&
    //   profiledetail.member_type_id !== "2" &&
    //   profiledetail.member_type_id !== "3" && {
    //     key: "23",
    //     icon: <BsBank />,
    //     label: (
    //       <NavLink>
    //         <p>BBPS Offline </p>
    //       </NavLink>
    //     ),
    //     children: [
    //       {
    //         key: "23.2",
    //         icon: <FaRupeeSign />,
    //         label: (
    //           <NavLink
    //             to={"/BbpsOffline1/part_payment"}
    //             // state={{ from: "/banking/aeps-cash-withdrawl", type: "aeps" }}
    //           >
    //             <p> Part Payment</p>
    //           </NavLink>
    //         ),
    //         onClick: () => {
    //           dispatch(setselectedTab("23.2"));
    //           dispatch(setHeadings("Part Payment"));
    //         },
    //       },
    //       {
    //         key: "23.3",
    //         icon: <FaRupeeSign />,
    //         label: (
    //           <NavLink
    //             to={"/BbpsOffline1/lease_part_payment"}
    //             // state={{ from: "/banking/aeps-aadharpay", type: "aadhar_pay" }}
    //           >
    //             <p>Lease Part Payment</p>
    //           </NavLink>
    //         ),
    //         onClick: () => {
    //           dispatch(setselectedTab("23.3"));
    //           dispatch(setHeadings("Lease Part Payment"));
    //         },
    //       },
    //       {
    //         key: "23.4",
    //         icon: <IoDocumentTextSharp />,
    //         label: (
    //           <NavLink
    //             to={"/BbpsOffline1/bawana_infra"}
    //             // state={{ from: "/banking/aeps-miniStatement", type: "aeps" }}
    //           >
    //             <p>Bawana Infra</p>
    //           </NavLink>
    //         ),
    //         onClick: () => {
    //           dispatch(setselectedTab("23.4"));
    //           dispatch(setHeadings("Bawana Infra"));
    //         },
    //       },
    //     ],
    //   },
    // {
    //   key: "17",
    //   icon: <BsBank2 />,
    //   label: (
    //     <NavLink
    //       to={
    //         checkDigiStatus()
    //           ? "/kycStatus"
    //           : memberServices.includes("20")
    //           ? checkYesBankStatus("/banking/aeps-yesbank")
    //           : "/not-available"
    //       }
    //     >
    //       <p>AEPS Bank-2</p>
    //     </NavLink>
    //   ),
    //   // children: [
    //   //   {
    //   //     key: "17.2",
    //   //     icon: <FaRupeeSign />,
    //   //     label: (
    //   //       <NavLink
    //   //         to={
    //   //           checkDigiStatus()
    //   //             ? "/kycStatus"
    //   //             : memberServices.includes("20")
    //   //             ? checkYesBankStatus("/banking/aepsyes-cash-withdrawl")
    //   //             : "/not-available"
    //   //         }
    //   //         state={{ from: "/banking/aepsyes-cash-withdrawl" }}
    //   //       >
    //   //         <p>Cash Withdrawal </p>
    //   //       </NavLink>
    //   //     ),
    //   //     onClick: () => {
    //   //       dispatch(setselectedTab("17.2"));
    //   //       dispatch(setHeadings("Cash Withdrawal "));
    //   //     },
    //   //   },
    //   //   {
    //   //     key: "17.4",
    //   //     icon: <IoDocumentTextSharp />,
    //   //     label: (
    //   //       <NavLink
    //   //         to={
    //   //           checkDigiStatus()
    //   //             ? "/kycStatus"
    //   //             : memberServices.includes("20")
    //   //             ? checkYesBankStatus("/banking/aepsyes-miniStatement")
    //   //             : "/not-available"
    //   //         }
    //   //         state={{ from: "/banking/aepsyes-miniStatement"}}
    //   //       >
    //   //         <p>Mini Statement</p>
    //   //       </NavLink>
    //   //     ),
    //   //     onClick: () => {
    //   //       dispatch(setselectedTab("17.4"));
    //   //       dispatch(setHeadings("Mini statement"));
    //   //     },
    //   //   },
    //   //   {
    //   //     key: "17.5",
    //   //     icon: <MdAccountBalance />,
    //   //     label: (
    //   //       <NavLink
    //   //         to={
    //   //         checkDigiStatus()
    //   //         ? "/kycStatus"
    //   //         : memberServices.includes("20")
    //   //         ? checkYesBankStatus("/banking/aepsyes-balanceEnquiry")
    //   //         : "/not-available"
    //   //         }
    //   //         state={{ from: "/banking/aepsyes-balanceEnquiry"}}
    //   //       >
    //   //         <p>Balance Enquiry</p>
    //   //       </NavLink>
    //   //     ),
    //   //     onClick: () => {
    //   //       dispatch(setselectedTab("17.5"));
    //   //       dispatch(setHeadings("Balance Enquiry"));
    //   //     },
    //   //   },
    //   // ],
    // },
    // {
    //   key: "13",
    //   icon: <BsQrCode />,
    //   label: (
    //     <NavLink
    //       to={
    //         checkDigiStatus()
    //           ? "/kycStatus"
    //           : memberServices.includes("18")
    //           ? "/upi"
    //           : "/not-available"
    //       }
    //     >
    //       <p>UPI</p>
    //     </NavLink>
    //   ),
    //   onClick: () => {
    //     dispatch(setselectedTab("13"));
    //     dispatch(setHeadings("UPI"));
    //   },
    // },
    // {
    //   key: "22",
    //   icon: <BsQrCode />,
    //   label: (
    //     <NavLink
    //       to={
    //         checkDigiStatus()
    //           ? "/kycStatus"
    //           : memberServices.includes("21")
    //           ? "/upi-dmt"
    //           : "/not-available"
    //       }
    //     >
    //       <p>UPI DMT</p>
    //     </NavLink>
    //   ),
    //   onClick: () => {
    //     dispatch(setselectedTab("22"));
    //     dispatch(setHeadings("UPI"));
    //   },
    // },

    profiledetail.member_type !== "State Head" &&
      (profiledetail.member_type_id === "2" || // MD
        profiledetail.member_type_id === "3" || // DT
        (profiledetail.member_type_id === "4" && // RT
          memberServices.includes("119"))) && {
        key: "10",
        icon: <FaMoneyCheck />,
        label: (
          <NavLink to="/fundRequest">
            <p>Fund Request</p>
          </NavLink>
        ),
        onClick: () => {
          dispatch(setselectedTab("10"));
          dispatch(setHeadings("Fund Request"));
        },
      },
    profiledetail.member_type !== "State Head" &&
      profiledetail.member_type_id !== "2" &&
      profiledetail.member_type_id !== "3" &&
      profiledetail.member_type !== "Retailer" && {
        key: "7",
        icon: <IoDocumentTextSharp />,
        label: (
          <NavLink
            to={memberServices.includes("16") ? "/uti" : "/not-available"}
          >
            <p>UTI</p>
          </NavLink>
        ),
        onClick: () => {
          dispatch(setselectedTab("7"));
          dispatch(setHeadings("UTI"));
        },
      },
    profiledetail.member_type !== "State Head" &&
      profiledetail.member_type_id !== "2" &&
      profiledetail.member_type_id !== "3" &&
      memberServices.includes("19") && {
        key: "16",
        icon: <FaRegAddressCard />,
        label: (
          <NavLink
            to={
              // checkDigiStatus()
              //   ? "/kycStatus"
              //   : memberServices.includes("19")
              //   ?
              "/panServices"
              // : "/not-available"
            }
          >
            <p>Pan Services</p>
          </NavLink>
        ),
        onClick: () => {
          dispatch(setselectedTab("16"));
          dispatch(setHeadings("Pan Services"));
        },
      },
    profiledetail.member_type !== "State Head" &&
      profiledetail.member_type_id !== "2" &&
      profiledetail.member_type_id !== "3" &&
      (memberServices.includes("102") ||
        memberServices.includes("120") ||
        memberServices.includes("9") ||
        memberServices.includes("122")) && {
        key: "4",
        icon: <BiTransferAlt />,
        label: (
          <NavLink to={"/payment-service"}>
            <p>Payment Services</p>
          </NavLink>
        ),
        onClick: () => {
          dispatch(setselectedTab("4"));
          dispatch(setHeadings("Payment Service"));
        },
      },
    // {
    //   key: "120",
    //   icon: <MdOutlinePayments />,
    //   label: (
    //     <NavLink
    //       to={
    //         memberServices.includes("120")
    //           ? "/pay-fusion-express-payout/get_remitter"
    //           : "/not-available"
    //       }
    //     >
    //       <p>PayFusion XPayout</p>
    //     </NavLink>
    //   ),
    //   onClick: () => {
    //     dispatch(setselectedTab("120"));
    //     dispatch(setHeadings("PayFusion XPayout"));
    //   },
    // },

    // {
    //   key: "4",
    //   icon: <BiTransferAlt />,
    //   label: (
    //     <NavLink
    //       to={
    //         checkDigiStatus()
    //           ? "/kycStatus"
    //           : profiledetail.dmt_kyc === "1" && memberServices.includes("4")
    //           ? "/dmt/remitters"
    //           : profiledetail.dmt_kyc !== "1" && memberServices.includes("4")
    //           ? "/dmt/submitKyc"
    //           : "/not-available"
    //       }
    //     >
    //       <p>DMT</p>
    //     </NavLink>
    //   ),
    //   onClick: () => {
    //     dispatch(setselectedTab("4"));
    //     dispatch(setHeadings("DMT"));
    //   },
    // },
    // {
    //   key: "300.2",
    //   icon: <MdOutlinePayments />,
    //   label: (
    //     <NavLink
    //       to={
    //         memberServices.includes("101")
    //           ? "/eko/payout"
    //           : memberServices.includes("5")
    //           ? checkDigiStatus()
    //             ? "/kycStatus"
    //             : "/payout/verification"
    //           : "/not-available"
    //       }
    //     >
    //       <p>Payout</p>
    //     </NavLink>
    //   ),
    //   onClick: () => {
    //     dispatch(setselectedTab("300.2"));
    //     dispatch(setHeadings("Payout"));
    //   },
    // },
    // {
    //   key: "5",
    //   icon: <MdOutlinePayments />,
    //   label: (
    //     <NavLink
    //       to={
    //         checkDigiStatus()
    //           ? "/kycStatus"
    //           : memberServices.includes("5")
    //           ? "/payout/verification"
    //           : "/not-available"
    //       }
    //     >
    //       <p>PayOut</p>
    //     </NavLink>
    //   ),
    //   onClick: () => {
    //     dispatch(setselectedTab("5"));
    //     dispatch(setHeadings("Payout"));
    //   },
    // },
    // {
    //   key: "14",
    //   icon: <BiRun />,
    //   label: (
    //     <NavLink
    //       to={
    //         memberServices.includes("102")
    //           ? "/eko/express-payout"
    //           : memberServices.includes("9")
    //           ? checkDigiStatus()
    //             ? "/kycStatus"
    //             : "/express-payout/get_remitter"
    //           : "/not-available"
    //       }
    //     >
    //       <p>Express Payout</p>
    //     </NavLink>
    //   ),
    //   onClick: () => {
    //     dispatch(setselectedTab("14"));
    //     dispatch(setHeadings("Payout"));
    //   },
    // },
    // {
    //   key: "14",
    //   icon: <BiRun />,
    //   label: (
    //     <NavLink
    //       to={
    //         checkDigiStatus()
    //           ? "/kycStatus"
    //           : memberServices.includes("9")
    //           ? "/express-payout"
    //           : "/not-available"
    //       }
    //     >
    //       <p>Express Payout</p>
    //     </NavLink>
    //   ),
    //   onClick: () => {
    //     dispatch(setselectedTab("14"));
    //     dispatch(setHeadings("Payout"));
    //   },
    // },
    // {
    //   key: "6",
    //   icon: <MdOutlineTravelExplore />,
    //   label: (
    //     <NavLink>
    //       <p>Travel</p>
    //     </NavLink>
    //   ),
    //   children: [
    //     {
    //       key: "6.1",
    //       icon: <MdOutlineFlight />,
    //       label: (
    //         <NavLink
    //           to={memberServices.includes("14") ? "/flights" : "/coming-soon"}
    //         >
    //           <p>Flight</p>
    //         </NavLink>
    //       ),
    //       onClick: () => {
    //         dispatch(setselectedTab("6.1"));
    //         dispatch(setHeadings("Flight ticket"));
    //       },
    //     },
    //     {
    //       key: "6.2",
    //       icon: <BsBusFrontFill />,
    //       label: (
    //         <NavLink
    //           to={memberServices.includes("13") ? "/bus" : "/coming-soon"}
    //         >
    //           <p>Bus </p>
    //         </NavLink>
    //       ),
    //       onClick: () => {
    //         dispatch(setselectedTab("6.2"));
    //         dispatch(setHeadings("Bus ticket"));
    //       },
    //     },
    //     {
    //       key: "6.3",
    //       icon: <BiSolidHotel />,
    //       label: (
    //         <NavLink
    //           to={memberServices.includes("12") ? "/hotel" : "/coming-soon"}
    //         >
    //           <p>Hotel </p>
    //         </NavLink>
    //       ),
    //       onClick: () => {
    //         dispatch(setselectedTab("6.3"));
    //         dispatch(setHeadings("Hotel Booking"));
    //       },
    //     },
    //   ],
    // },
    profiledetail.member_type !== "Retailer" && {
      key: "15",
      icon: <BsPeople />,
      label: (
        <NavLink to={"/memberList"}>
          <p>Members</p>
        </NavLink>
      ),
      onClick: () => {
        dispatch(setselectedTab("15"));
        dispatch(setHeadings("Member List"));
      },
    },
    profiledetail.member_type !== "State Head" &&
      (profiledetail.member_type_id === "2" ||
        profiledetail.member_type_id === "3" ||
        (profiledetail.member_type_id === "4" &&
          memberServices.includes("7"))) && {
        key: "44",
        icon: <FaRupeeSign />,
        label: (
          <NavLink to="/give-topup">
            <p>Wallet to Wallet</p>
          </NavLink>
        ),
        onClick: () => {
          dispatch(setselectedTab("44"));
        },
      },
    profiledetail.member_type !== "State Head" && {
      key: "12",
      icon: <AiOutlineWallet />,
      label: (
        <NavLink to={"/Report/wallet"}>
          <p>Ledger</p>
        </NavLink>
      ),
      onClick: () => {
        dispatch(setselectedTab("12"));
        dispatch(setHeadings("Ledger Report"));
      },
    },

    // {
    //   key: "110",
    //   icon: <AiOutlineHistory />,
    //   label: <p>Eko Reports</p>,
    //   children: [
    //     // {
    //     //   key: "110.1",
    //     //   // icon: <MdAccountBalance />,
    //     //   label: (
    //     //     <NavLink
    //     //       to={"/Report/eko/payout"}
    //     //     >
    //     //       <Tooltip title="Eko Payout">
    //     //         <p>Eko Payout</p>
    //     //       </Tooltip>
    //     //     </NavLink>
    //     //   ),
    //     //   onClick: () => {
    //     //     dispatch(setselectedTab("110.1"));
    //     //   },
    //     // },
    //     {
    //       key: "110.2",
    //       // icon: <MdAccountBalance />,
    //       label: (
    //         <NavLink
    //           to={"/Report/eko/aadhar"}
    //         >
    //           <Tooltip title="Eko Aadhar">
    //             <p>Eko Aadhar</p>
    //           </Tooltip>
    //         </NavLink>
    //       ),
    //       onClick: () => {
    //         dispatch(setselectedTab("110.2"));
    //       },
    //     },
    //     {
    //       key: "110.3",
    //       // icon: <MdAccountBalance />,
    //       label: (
    //         <NavLink to={"/Report/eko/pan"}>
    //           <Tooltip title="Eko Pan">
    //             <p>Eko Pan</p>
    //           </Tooltip>
    //         </NavLink>
    //       ),
    //       onClick: () => {
    //         dispatch(setselectedTab("110.3"));
    //       },
    //     },
    //     {
    //       key: "110.4",
    //       // icon: <MdAccountBalance />,
    //       label: (
    //         <NavLink
    //           to={"/Report/eko/bankVerify"}
    //         >
    //           <Tooltip title="Eko Bank Verify">
    //             <p>Eko Bank Verify</p>
    //           </Tooltip>
    //         </NavLink>
    //       ),
    //       onClick: () => {
    //         dispatch(setselectedTab("110.4"));
    //       },
    //     },
    //     {
    //       key: "110.5",
    //       // icon: <MdAccountBalance />,
    //       label: (
    //         <NavLink to={"/Report/eko/cms"}>
    //           <Tooltip title="Eko CMS">
    //             <p>Eko CMS</p>
    //           </Tooltip>
    //         </NavLink>
    //       ),
    //       onClick: () => {
    //         dispatch(setselectedTab("110.5"));
    //       },
    //     },
    //     // {
    //     //   key: "110.6",
    //     //   // icon: <MdAccountBalance />,
    //     //   label: (
    //     //     <NavLink to={"/Report/eko/bbps"}>
    //     //       <Tooltip title="Eko BBPS">
    //     //         <p>Eko BBPS</p>
    //     //       </Tooltip>
    //     //     </NavLink>
    //     //   ),
    //     //   onClick: () => {
    //     //     dispatch(setselectedTab("110.6"));
    //     //   },
    //     // },
    //     {
    //       key: "110.7",
    //       // icon: <MdAccountBalance />,
    //       label: (
    //         <NavLink
    //           to={"/Report/eko/bbps-offline"}
    //         >
    //           <Tooltip title="Eko BBPS Offline">
    //             <p>Eko BBPS Offline</p>
    //           </Tooltip>
    //         </NavLink>
    //       ),
    //       onClick: () => {
    //         dispatch(setselectedTab("110.7"));
    //       },
    //     },
    //     {
    //       key: "110.8",
    //       // icon: <MdAccountBalance />,
    //       label: (
    //         <NavLink
    //           to={"/Report/eko/credit-card"}
    //         >
    //           <Tooltip title="Eko Credit Card">
    //             <p>Eko Credit Card</p>
    //           </Tooltip>
    //         </NavLink>
    //       ),
    //       onClick: () => {
    //         dispatch(setselectedTab("110.8"));
    //       },
    //     },
    //   ],
    // },
    {
      key: "1211",
      icon: <MdReport />,
      label: (
        <NavLink to={"/Report_main"}>
          <p>Reports</p>
        </NavLink>
      ),
      onClick: () => {
        dispatch(setselectedTab("1211"));
        dispatch(setHeadings(" Report"));
      },
    },
    // {
    //   key: "11",
    //   icon: <AiOutlineHistory />,
    //   label: <p>Reports</p>,
    //   children: [
    //     {
    //       key: "11.57",
    //       // icon: <MdAccountBalance />,
    //       label: (
    //         <NavLink to={"/Report/cash-transaction"}>
    //           <Tooltip title="CashWithdrawl Report">
    //             <p>Aeps-2 Report</p>
    //           </Tooltip>
    //         </NavLink>
    //       ),
    //       onClick: () => {
    //         dispatch(setselectedTab("11.57"));
    //         dispatch(setHeadings("Credo Aeps Transaction"));
    //       },
    //     },
    //     {
    //       key: "11.1",
    //       // icon: <MdAccountBalance />,
    //       label: (
    //         <NavLink to={"/Report/cash-withdrawl"}>
    //           <Tooltip title="CashWithdrawl Report">
    //             <p>Cash Withdrawal </p>
    //           </Tooltip>
    //         </NavLink>
    //       ),
    //       onClick: () => {
    //         dispatch(setselectedTab("11.1"));
    //         dispatch(setHeadings("Cash Withdrawal Report"));
    //       },
    //     },
    //     {
    //       key: "11.2",
    //       // icon: <MdAccountBalance />,
    //       label: (
    //         <NavLink to={"/Report/Mini-statement"}>
    //           <Tooltip title="MiniStatement Report">
    //             <p>Mini Statement</p>
    //           </Tooltip>
    //         </NavLink>
    //       ),
    //       onClick: () => {
    //         dispatch(setselectedTab("11.2"));
    //         dispatch(setHeadings("Mini Statement Report"));
    //       },
    //     },

    //     {
    //       key: "11.10",
    //       label: (
    //         <NavLink to={"/Report/fund-request"}>
    //           <p>Fund Request</p>
    //         </NavLink>
    //       ),
    //       onClick: () => {
    //         dispatch(setselectedTab("11.10"));
    //         dispatch(setHeadings("Fund Request Report"));
    //       },
    //     },
    //     // {
    //     //   key: "11.14",
    //     //   label: (
    //     //     <NavLink to={ "/Report/yesBank"}>
    //     //       <p>Yes Bank AEPS</p>
    //     //     </NavLink>
    //     //   ),
    //     //   onClick: () => {
    //     //     dispatch(setselectedTab("11.14"));
    //     //     dispatch(setHeadings("Yes Bank AEPS"));
    //     //   },
    //     // },
    //     {
    //       key: "11.3",
    //       // icon: <MdAccountBalance />,
    //       label: (
    //         <NavLink to={"/Report/aadharpay"}>
    //           <Tooltip title="MiniStatement Report">
    //             <p>Aadhar Pay</p>
    //           </Tooltip>
    //         </NavLink>
    //       ),
    //       onClick: () => {
    //         dispatch(setselectedTab("11.3"));
    //         dispatch(setHeadings("Aadhar Pay Report"));
    //       },
    //     },
    //     {
    //       key: "11.12",
    //       // icon: <MdAccountBalance />,
    //       label: (
    //         <NavLink to={"/Report/balance-enquirey"}>
    //           <Tooltip title="Balance Enquiry ">
    //             <p>Balance Enquiry </p>
    //           </Tooltip>
    //         </NavLink>
    //       ),
    //       onClick: () => {
    //         dispatch(setselectedTab("11.12"));
    //         dispatch(setHeadings("Balance Enquiry  Report"));
    //       },
    //     },
    //     {
    //       key: "11.5",
    //       label: (
    //         <NavLink to={"/Report/recharge"}>
    //           <p>Recharge</p>
    //         </NavLink>
    //       ),
    //       onClick: () => {
    //         dispatch(setselectedTab("11.5"));
    //         dispatch(setHeadings("Recharge Report"));
    //       },
    //     },
    //     // {
    //     //   key: "11.4",
    //     //   label: (
    //     //     <NavLink to={"/Report/payout"}>
    //     //       <p>Payout</p>
    //     //     </NavLink>
    //     //   ),
    //     //   onClick: () => {
    //     //     dispatch(setselectedTab("11.4"));
    //     //     dispatch(setHeadings("Payout Report"));
    //     //   },
    //     // },
    //     {
    //       key: "11.11",
    //       label: (
    //         <NavLink to={"/Report/xpressPayout"}>
    //           <p>XpressPayout</p>
    //         </NavLink>
    //       ),
    //       onClick: () => {
    //         dispatch(setselectedTab("11.11"));
    //       },
    //     },
    //     // {
    //     //   key: "11.16",
    //     //   label: (
    //     //     <NavLink to={"/Report/payfusion-xpressPayout"}>
    //     //       <p>PayFusion XpressPayout</p>
    //     //     </NavLink>
    //     //   ),
    //     //   onClick: () => {
    //     //     dispatch(setselectedTab("11.16"));
    //     //   },
    //     // },
    //     {
    //       key: "11.6",
    //       label: (
    //         <NavLink to={"/Report/bbps"}>
    //           <p>BBPS</p>
    //         </NavLink>
    //       ),
    //       onClick: () => {
    //         dispatch(setselectedTab("11.6"));
    //         dispatch(setHeadings("BBPS Report"));
    //       },
    //     },
    //     {
    //       key: "11.7",
    //       label: (
    //         <NavLink to={"/Report/dmt"}>
    //           <p>Dmt</p>
    //         </NavLink>
    //       ),
    //       onClick: () => {
    //         dispatch(setselectedTab("11.7"));
    //         dispatch(setHeadings("DMT Report"));
    //       },
    //     },
    //     // {
    //     //   key: "11.17",
    //     //   label: (
    //     //     <NavLink to={"/Report/m-atm"}>
    //     //       <p>M-ATM</p>
    //     //     </NavLink>
    //     //   ),
    //     //   onClick: () => {
    //     //     dispatch(setselectedTab("11.17"));
    //     //     dispatch(setHeadings("M ATM Report"));
    //     //   },
    //     // },
    //     // {
    //     //   key: "11.8",
    //     //   label: (
    //     //     <NavLink to={"/Report/uti"}>
    //     //       <p>Uti</p>
    //     //     </NavLink>
    //     //   ),
    //     //   onClick: () => {
    //     //     dispatch(setselectedTab("11.8"));
    //     //     dispatch(setHeadings("Uti Report"));
    //     //   },
    //     // },
    //     {
    //       key: "11.13",
    //       label: (
    //         <NavLink to={"/Report/nsdl"}>
    //           <p>Nsdl</p>
    //         </NavLink>
    //       ),
    //       onClick: () => {
    //         dispatch(setselectedTab("11.13"));
    //         dispatch(setHeadings("Nsdl Report"));
    //       },
    //     },
    //     // {
    //     //   key: "11.15",
    //     //   label: (
    //     //     <NavLink to={"/Report/upi-dmt"}>
    //     //       <p>Upi DMT</p>
    //     //     </NavLink>
    //     //   ),
    //     //   onClick: () => {
    //     //     dispatch(setselectedTab("11.15"));
    //     //     dispatch(setHeadings("Upi Dmt Report"));
    //     //   },
    //     // },
    //     // {
    //     //   key: "110.2",
    //     //   // icon: <MdAccountBalance />,
    //     //   label: (
    //     //     <NavLink to={"/Report/eko/aadhar"}>
    //     //       <Tooltip title="Aadhar">
    //     //         <p>Aadhar</p>
    //     //       </Tooltip>
    //     //     </NavLink>
    //     //   ),
    //     //   onClick: () => {
    //     //     dispatch(setselectedTab("110.2"));
    //     //   },
    //     // },
    //     {
    //       key: "110.3",
    //       // icon: <MdAccountBalance />,
    //       label: (
    //         <NavLink to={"/Report/eko/pan"}>
    //           <Tooltip title="Pan">
    //             <p>Pan</p>
    //           </Tooltip>
    //         </NavLink>
    //       ),
    //       onClick: () => {
    //         dispatch(setselectedTab("110.3"));
    //       },
    //     },
    //     {
    //       key: "110.4",
    //       // icon: <MdAccountBalance />,
    //       label: (
    //         <NavLink to={"/Report/eko/bankVerify"}>
    //           <Tooltip title="Bank Verify">
    //             <p>Bank Verify</p>
    //           </Tooltip>
    //         </NavLink>
    //       ),
    //       onClick: () => {
    //         dispatch(setselectedTab("110.4"));
    //       },
    //     },
    //     profiledetail.member_type === "Retailer" && {
    //       key: "110.11",
    //       // icon: <MdAccountBalance />,
    //       label: (
    //         <NavLink to={"/Report/refundTransaction"}>
    //           <Tooltip title="Refund Transaction">
    //             <p>Refund Transaction</p>
    //           </Tooltip>
    //         </NavLink>
    //       ),
    //       onClick: () => {
    //         dispatch(setselectedTab("110.11"));
    //       },
    //     },
    //     {
    //       key: "110.5",
    //       // icon: <MdAccountBalance />,
    //       label: (
    //         <NavLink to={"/Report/eko/cms"}>
    //           <Tooltip title="CMS">
    //             <p>CMS</p>
    //           </Tooltip>
    //         </NavLink>
    //       ),
    //       onClick: () => {
    //         dispatch(setselectedTab("110.5"));
    //       },
    //     },
    //     // {
    //     //   key: "110.6",
    //     //   // icon: <MdAccountBalance />,
    //     //   label: (
    //     //     <NavLink to={"/Report/eko/bbps"}>
    //     //       <Tooltip title="BBPS">
    //     //         <p>BBPS</p>
    //     //       </Tooltip>
    //     //     </NavLink>
    //     //   ),
    //     //   onClick: () => {
    //     //     dispatch(setselectedTab("110.6"));
    //     //   },
    //     // },
    //     // {
    //     //   key: "110.7",
    //     //   // icon: <MdAccountBalance />,
    //     //   label: (
    //     //     <NavLink to={"/Report/eko/bbps-offline"}>
    //     //       <Tooltip title="BBPS Offline">
    //     //         <p>BBPS Offline</p>
    //     //       </Tooltip>
    //     //     </NavLink>
    //     //   ),
    //     //   onClick: () => {
    //     //     dispatch(setselectedTab("110.7"));
    //     //   },
    //     // },
    //     {
    //       key: "110.8",
    //       // icon: <MdAccountBalance />,
    //       label: (
    //         <NavLink to={"/Report/eko/credit-card"}>
    //           <Tooltip title="Credit Card">
    //             <p>Credit Card</p>
    //           </Tooltip>
    //         </NavLink>
    //       ),
    //       onClick: () => {
    //         dispatch(setselectedTab("110.8"));
    //       },
    //     },
    //     profiledetail.member_type_id !== "1" &&
    //       profiledetail.member_type_id !== "4" && {
    //         key: "110.9",
    //         // icon: <MdAccountBalance />,
    //         label: (
    //           <NavLink to={"/Report/commission_member"}>
    //             <Tooltip title="Commission Member Report">
    //               <p>Commission Member Report</p>
    //             </Tooltip>
    //           </NavLink>
    //         ),
    //         onClick: () => {
    //           dispatch(setselectedTab("110.9"));
    //         },
    //       },
    //   ],
    // },
    profiledetail.member_type !== "State Head" &&
      profiledetail.member_type_id !== "2" &&
      profiledetail.member_type_id !== "3" && {
        key: "101",
        icon: <FaCertificate />,
        label: <p>Download Certificate</p>,
        onClick: () => {
          dispatch(setselectedTab("101"));
          axios
            .get(
              APIURL +
                Globalendpoints.downLoadCertificate +
                `?primary_color=` +
                ThemeColor.primary.replace("#", "") +
                "&secondary_color=" +
                ThemeColor.primaryhover.replace("#", ""),
              {
                responseType: "blob",
                headers: {
                  "Content-Type": "application/pdf",
                  // Range: "bytes=0-999999",
                  Authorization: `Bearer ${getLocalStorageItem(
                    "access_token",
                  )}`,
                },
              },
            )
            .then((res) => {
              saveAs(res.data, "certificate.pdf");
            })
            .catch((err) => console.log(err));
        },
      },
  ];

  if (profiledetail.member_type?.toLowerCase() !== "retailer") {
    if (profiledetail.bank2_aeps_onboard !== 1) {
      return list.filter((i) => i.key !== "171");
    }
  } else {
    if (profiledetail.bank2_aeps_onboard !== 1) {
      return list.filter((i) => i.key !== "171");
    } else {
      return list.filter((i) => i.key !== "15" && i.key !== "44");
    }
  }
  return list;
};
